import React from 'react';
import { PostResponseSchema } from '@api/client';
import PostCardRecordedPostType from './PostCardRecordedPostType';

interface Props {
  post: PostResponseSchema;
  onVideoClick?: (post: PostResponseSchema) => void;
  onImageClick?: (post: PostResponseSchema) => void;
  wrapperStyle?: React.CSSProperties;
}

export default function PostCardRecorded(props: Props): React.ReactElement {
  return <PostCardRecordedPostType {...props} />;
}
